import { ApiCaller } from '@graphit/callers'
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { router } from '~/app/router'

export const authQueryOptions = queryOptions({
	queryKey: ['auth'],
	queryFn: ApiCaller.getUserStatus,
	staleTime: Infinity
})

export const useAuthQuery = () => useQuery(authQueryOptions)

export const useLoginMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async ({ email, password }: { email: string; password: string }) =>
			ApiCaller.login(email, password),
		async onSuccess() {
			await queryClient.invalidateQueries({ queryKey: ['auth'] })
			await router.invalidate()
		}
	})
}

export const useChangePasswordMutation = () =>
	useMutation({
		mutationFn: async ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) =>
			ApiCaller.changePassword(currentPassword, newPassword)
	})

export const useSignupMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		async mutationFn({ email, password }: { email: string; password: string }) {
			await ApiCaller.signup('', email, password)
		},
		async onSuccess() {
			await queryClient.invalidateQueries({ queryKey: ['auth'] })
			await router.invalidate()
		}
	})
}

export const useResetPasswordEmailMutation = () =>
	useMutation({
		mutationFn: async (email: string) => ApiCaller.resetPasswordEmail(email)
	})

export const useResetPasswordMutation = () =>
	useMutation({
		mutationFn: async ({ token, password }: { token: string; password: string }) =>
			ApiCaller.resetPassword(token, password)
	})
